<script>

    import { replace } from 'svelte-spa-router'
    import { adminStore } from '../stores'
    import { isPermission } from '../$methods/permissions.methods'

    import View from '../$layouts/view.layout.svelte'
    import PageHeader from '../$components/page.header.svelte'
    import Modal from '../$components/modal.container.svelte'

    import Overweights from './component.overweights.svelte'
    import ChargesUpload from './component.charges.upload.svelte'

    if(!isPermission($adminStore, 'UsersView.Charges.View'))
        replace('/404')

    let list

</script>

<View>
    <PageHeader title="Sobrepesos" subtitle="Archivos de cargos de sobrepeso registrados" />
    <Overweights bind:this={list} />
</View>

<Modal id="charges_upload_modal" title="Cargar cargos" tall>
    <ChargesUpload on:created={() => list?.getImports()} />
</Modal>
